interface ConfidenceGaugeProps {
    value: number; // 0–100
    size?: 'sm' | 'md' | 'lg';
}

const SIZE_MAP = {
    sm: { outer: 64, stroke: 5, fontSize: 'text-sm' },
    md: { outer: 96, stroke: 7, fontSize: 'text-lg' },
    lg: { outer: 128, stroke: 9, fontSize: 'text-2xl' },
};

const getColor = (v: number) => {
    if (v >= 80) return { stroke: '#10b981', bg: '#10b98118', label: 'High', cls: 'text-emerald-400' };
    if (v >= 50) return { stroke: '#f59e0b', bg: '#f59e0b18', label: 'Medium', cls: 'text-amber-400' };
    return { stroke: '#ef4444', bg: '#ef444418', label: 'Low', cls: 'text-red-400' };
};

export default function ConfidenceGauge({ value, size = 'md' }: ConfidenceGaugeProps) {
    const { outer, stroke, fontSize } = SIZE_MAP[size];
    const { stroke: color, label, cls } = getColor(value);
    const radius = (outer - stroke * 2) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (value / 100) * circumference;
    const center = outer / 2;

    return (
        <div className="flex flex-col items-center gap-2">
            <div className="relative" style={{ width: outer, height: outer }}>
                <svg width={outer} height={outer} className="-rotate-90">
                    {/* Background track */}
                    <circle
                        cx={center}
                        cy={center}
                        r={radius}
                        fill="none"
                        stroke="rgba(255,255,255,0.06)"
                        strokeWidth={stroke}
                    />
                    {/* Progress arc */}
                    <circle
                        cx={center}
                        cy={center}
                        r={radius}
                        fill="none"
                        stroke={color}
                        strokeWidth={stroke}
                        strokeLinecap="round"
                        strokeDasharray={circumference}
                        strokeDashoffset={offset}
                        style={{ transition: 'stroke-dashoffset 1s ease-out' }}
                    />
                </svg>
                {/* Center value */}
                <div className="absolute inset-0 flex flex-col items-center justify-center">
                    <span className={`font-bold leading-none ${fontSize} text-white`}>{value}</span>
                    <span className="text-[10px] text-slate-500 mt-0.5">/ 100</span>
                </div>
            </div>
            <span className={`text-xs font-semibold ${cls}`}>{label} Confidence</span>
        </div>
    );
}
